import React from 'react';
import { usePagination, DOTS } from '../../hooks/usePagination';

import { ReactComponent as ArrowBack } from '../../assets/novosicones/arrow_back.svg';
import { ReactComponent as ArrowForward } from '../../assets/novosicones/arrow_forward.svg';
import { PaginationContainer, PaginationItem } from './style';

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage = 1,
    pageSize,
    tema,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  if (paginationRange?.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange?.length - 1];
  return (
    <PaginationContainer>
      <PaginationItem
        key={'prevPage'}
        className={`pagination-item ${currentPage === 1 ? 'disabled' : ''}`}
        onClick={onPrevious}
        tema={tema}
        id={'btnPaginaAnterior'}
      >
        <ArrowBack fill={tema?.primaryColor} />
      </PaginationItem>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return <PaginationItem key={'dots' + index}>&#8230;</PaginationItem>;
        }

        return (
          <PaginationItem
            key={'page' + index}
            tema={tema}
            className={`pagination-item ${
              pageNumber === currentPage ? 'selected' : ''
            }`}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber < 10 ? String(pageNumber).padStart(2, '0') : pageNumber}
          </PaginationItem>
        );
      })}
      <PaginationItem
        key={'nextPage'}
        className={`pagination-item ${
          currentPage === lastPage ? 'disabled' : ''
        }`}
        onClick={onNext}
        id={'btnProximaPagina'}
      >
        <ArrowForward fill={tema?.primaryColor} />
      </PaginationItem>
    </PaginationContainer>
  );
};

export default Pagination;
